angular.module('gym.contacts').controller('AddStripePaymentDetailsCtrl', ["$scope", "$modalInstance", "$timeout", "$http", "PaymentDetailsSharingService", "CreditCardValidationService", "flash", "gym", "contact", "customer", "paymentAccount", function($scope, $modalInstance, $timeout, $http, PaymentDetailsSharingService, CreditCardValidationService, flash, gym, contact, customer, paymentAccount) {
  var cardElement, cardReady, clearDataAfterSubmit, defaultPaymentMethod, elements, generateIntent, getPaymentMethodReference, onCardChange, ref, stripe, stripeResponseHandler;
  $scope.gym = gym;
  $scope.contact = contact;
  defaultPaymentMethod = _.find(customer, function(paymentMethod) {
    return paymentMethod.default;
  });
  $scope.isShared = (defaultPaymentMethod != null ? (ref = defaultPaymentMethod.all_contacts) != null ? ref.length : void 0 : void 0) > 1;
  $scope.sharePaymentDetails = function() {
    $modalInstance.dismiss();
    return PaymentDetailsSharingService.share(contact, customer);
  };
  stripe = Stripe(paymentAccount.public_key);
  elements = stripe.elements();
  cardElement = elements.create('card');
  $timeout(function() {
    return cardElement.mount('#card');
  });
  cardReady = false;
  onCardChange = function() {
    return cardElement.on('change', function(event) {
      return $timeout(function() {
        var displayErrorEl;
        cardReady = event.complete;
        displayErrorEl = document.getElementById('cardErrors');
        if (displayErrorEl != null) {
          if (event.error) {
            return displayErrorEl.textContent = event.error.message;
          } else {
            return displayErrorEl.textContent = '';
          }
        }
      });
    });
  };
  onCardChange();
  generateIntent = function() {
    var url;
    url = `/gyms/${gym.id}/contacts/${contact.id}/stripe/generate_intent`;
    return $http.post(url).then(function(response) {
      return $scope.paymentIntent = response.data;
    });
  };
  generateIntent();
  $scope.formReady = function() {
    return $scope.nameValid($scope.name) && cardReady;
  };
  $scope.submitCard = function() {
    var form;
    form = document.getElementById('cardForm');
    return form.addEventListener('submit', function(e) {
      return $timeout(function() {
        $scope.isLoading = true;
        e.preventDefault();
        return getPaymentMethodReference();
      });
    });
  };
  $scope.nameValid = function(name) {
    return CreditCardValidationService.nameValid(name);
  };
  getPaymentMethodReference = function() {
    var options;
    options = {
      billing_details: {
        name: document.getElementById('name').value
      }
    };
    return stripe.confirmCardSetup($scope.paymentIntent.client_secret, {
      payment_method: {
        card: cardElement,
        billing_details: options.billing_details
      }
    }).then(function(setupIntentResult) {
      return $timeout(function() {
        var paymentMethodId;
        if (setupIntentResult.error) {
          $modalInstance.close();
          return flash.error = 'We are unable to authenticate your payment method. Please choose a different payment method and try again.';
        } else {
          paymentMethodId = setupIntentResult.setupIntent.payment_method;
          return stripe.createPaymentMethod('card', cardElement, options).then(function(createPaymentMethodResponse) {
            return $timeout(function() {
              return stripeResponseHandler(paymentMethodId, createPaymentMethodResponse.paymentMethod);
            });
          });
        }
      });
    });
  };
  clearDataAfterSubmit = function() {
    return cardElement.clear();
  };
  stripeResponseHandler = function(token, paymentMethodReference) {
    var params, url;
    $scope.isLoading = true;
    params = {
      payment_method: {
        payment_method_reference: token,
        name: paymentMethodReference.billing_details.name,
        card_brand: paymentMethodReference.card.brand,
        last4: paymentMethodReference.card.last4,
        exp_month: paymentMethodReference.card.exp_month,
        exp_year: paymentMethodReference.card.exp_year,
        address_zip: paymentMethodReference.billing_details.address.postal_code
      }
    };
    url = `gyms/${gym.id}/contacts/${contact.id}/stripe`;
    return $http.post(url, params).then(function() {
      clearDataAfterSubmit();
      return $modalInstance.close();
    }, function(response) {
      $scope.isLoading = false;
      return $scope.error = response.data.error || "There was an error processing the request.";
    });
  };
  return $scope.cancel = function() {
    return $modalInstance.dismiss();
  };
}]);
